export const LOAD_SCOUTING_DATA = 'app/Scouting/LOAD_SCOUTING_DATA';
export const LOAD_CURRENT_SCOUTING = 'app/Scouting/LOAD_CURRENT_SCOUTING';
export const SET_SCOUTING_DATA = 'app/Scouting/SET_SCOUTING_DATA';
export const SET_CURRENT_SCOUTING = 'app/Scouting/SET_CURRENT_SCOUTING';
export const SCOUTING_HOVERED = 'app/Scouting/SCOUTING_HOVERED';
export const ADDING_NEW_SCOUTING = 'app/Scouting/ADDING_NEW_SCOUTING';
export const RESET_SCOUTING = 'app/Scouting/RESET_SCOUTING';
export const MOBILE_SHOW_MAP = 'app/Scouting/MOBILE_SHOW_MAP';
export const CLICKED_SCOUTING = 'app/Scouting/CLICKED_SCOUTING';
